<template>
    <div class="overview" v-if="customStatuses.length > 0">
        <div :key="status.id" v-for="status in customStatuses"
             class="overview__item overview__item--condensed show-control">
            <h3 class="overview__title">{{ status.title }}</h3>
            <p class="overview__description" v-if="status.description">{{ status.description }}</p>
            <p class="overview__description">
                <span class="overview__partials">
                    Zobrazení ceny <strong class="text--info">{{ status.priceVisible ? 'Ano' : 'Ne' }}</strong><br>
                    Barevné znázornění v katalogu <span class="current-color current-color--small"
                                                        v-bind:style="{ backgroundColor: status.colorCode }"></span>
                </span>
            </p>
            <div class="overview__controls z1 m--t-1">
                <custom-button @click="update(status.id)" iconic><span icon edit></span>Upravit</custom-button>
                <custom-button @click="remove(status)" iconic class="visible-on-overview-hover"><span icon
                                                                                                      remove></span>Odstranit
                </custom-button>
            </div>
        </div>
    </div>
</template>

<script>
import UpdateStatusDialog from './UpdateStatusDialog';
import {defaultModalParameters} from 'domovio-core/src/system/modal/modal.params';
import CustomButton from 'domovio-core/src/components/Button/CustomButton';

export default {
    name:       'StatusList',
    components: {CustomButton},
    computed:   {
        customStatuses() {
            return this.$store.getters['projects/project/customStatuses'];
        }
    },
    methods:    {
        update(statusId) {
            this.$modal.show(UpdateStatusDialog, {statusId}, defaultModalParameters());
        },
        remove(status) {
            const {id, title} = status;
            this.$modal.show('dialog', {
                title:   'Opravdu chcete status <strong>' + title + '</strong> odstranit?',
                text:    'Jednotkám navázaným k tomuto statusu bude automaticky přidělen stav <strong>Volný</strong>',
                buttons: [
                    {
                        title:   'Zrušit',
                        handler: () => this.$modal.hide('dialog')
                    }, {
                        title:   'Odstranit',
                        handler: () => {
                            this.$store.dispatch('projects/project/removeStatus', id)
                            this.$modal.hide('dialog');
                        }
                    },
                ]
            });
        }
    }
}
</script>
